<template>
    <div class="single-event">
        <EventMetadata :event="event"/>
        <CuentaAtras @tiempoTerminado="tiempoTerminado = true"/>
        <PageTitle 
            title="" 
            :style="'background-image: url(&quot;' + event.imagen + '&quot;);'"
        />
        
        <CabeceraClubs
            v-if="event.equipo_local"
            :event="event"
        />

        <CabeceraImagen
            v-if="! event.equipo_local"
            :event="event"
        />

        <template v-if="event.status == 3">
            <section class="padding-vertical-content">
                <div class="container">
                    <div class="row align-items-center" style="height: 300px">
                        <div class="col-12 align-items-center">
                            <h1 class="text-center dark-content p-4">{{ $t('eventos.aplazado') }}</h1>
                        </div>                            
                    </div>
                </div>
            </section>
        </template>
        <template v-else-if="event.venta_cerrada">
            <section class="padding-vertical-content">
                <div class="container">
                    <div class="row align-items-center" style="height: 300px">
                        <div class="col-12 align-items-center">
                            <h1 v-if="event.status === 2" class="text-center dark-content p-4">{{ $t('eventos.cancelado') }}</h1>
                            <h1 v-else-if="evento.finalizado" class="text-center dark-content p-4">{{ $t('eventos.finalizado') }}</h1>
                            <h1 v-else class="text-center dark-content p-4">{{ $t('partidos.proximamente') }}</h1>
                        </div>                            
                    </div>
                </div>
            </section>
        </template>
        <template v-else>
            <ProcesoCompraConRecinto
                v-if="event && event.tiene_recinto && refresh"
                :tiempoTerminado="tiempoTerminado"
                :event="event"
                :sesion_id="$route.params.sesion_id"
                @reset="recargar"
            />

            <ProcesoCompraSinRecinto
                v-if="event && !event.tiene_recinto && refresh"
                :tiempoTerminado="tiempoTerminado"
                :event="event"
                :sesion_id="$route.params.sesion_id"
                @reset="recargar"
            />
        </template>
    </div>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import CuentaAtras from '@/components/frontend/events/compra/CuentaAtras';
    import ProcesoCompraSinRecinto from '@/components/frontend/events/compra/ProcesoCompraSinRecinto';
    import ProcesoCompraConRecinto from '@/components/frontend/events/compra/ProcesoCompraConRecinto';
    import EventMetadata from "../../../../../components/metadata/EventMetadata";
    import CabeceraClubs from '@/components/frontend/events/show/CabeceraClubs';
    import CabeceraImagen from '@/components/frontend/events/show/CabeceraImagen';
    import { useHead } from '@/composables/common/seo/useHead';

    export default {
        props: ['event_id', 'event', 'entradas'],
        data() {
            return {
                zonas: null,
                datos: {},
                formulario: null,
                session_id: null,
                terminos: false,
                newsletter: false,
                paso2: false,
                paso3: false,
                loading: false,
                tiempoTerminado: false,
                refresh: true,
            }
        },
        created() {
            useHead(this.event?.name || 'Evento');
            if(this.event.venta_online_cerrada || this.event.venta_online_cerrada_definitiva || this.event.solo_abonados || this.event.status == 0) {
                if(!this.$route.query.venta_online || !this.$route.query.venta_online == 'test') {
                    this.$router.push({ name: 'front.eventos.index' });
                }
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            mostrar_header() {
                if(this.$route.name == 'front.home') {
                    return false;
                }
                if(this.$route.name == 'login') {
                    return false;
                }

                return true;                
            }
        },
        methods: {
            setMetaTags() {
                const title = document.querySelectorAll('[property="og:title"]');
                for(var index in title) {
                    if(title[index] != 2) {
                        title[index].content = this.event.name;  
                    }                      
                } 

                const image = document.querySelectorAll('[property="og:image"]');
                for(var index2 in image) {
                    if(image[index2] != 2) {
                        image[index2].content = this.event.imagen;  
                    }                      
                }                 
            },
            volver() {
                this.tiempoTerminado = true;
            },
            recargar(){
                return new Promise(() => {
                    this.refresh = false;
                    this.$nextTick(() => {
                        this.refresh = true;
                    })
                    this.tiempoTerminado = false;
                })
            }
        },
        components: {
            EventMetadata, PageTitle, CuentaAtras, ProcesoCompraSinRecinto, ProcesoCompraConRecinto, CabeceraClubs, CabeceraImagen
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
